/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function deviceTargetSubDevices(dev: any): string[] {
  return (dev.targetedDeviceTypes || [])
    .concat(dev.targetedOSes || [])
    .concat(dev.targetedBrands || []);
}

export function previewParams(creative: any): any {
  return {
    creativeId: creative.id,
    networkId: creative.network?.id,
    creativeWidth: creative.width,
    creativeHeight: creative.height,
    lineItemId: creative.lineItemId || creative.lineItem?.id,
    lineItemCode: creative.lineItemCode || creative.lineItem?.lineItemCode
  };
}

export function hasAmount(value: any): boolean {
  return !!_.get(value, 'amount');
}
